import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import VideoUtilityService from '@/services/course/lesson/video-utility-service';

interface Props {
  link: string;
}

function YoutubeIFrame({ link }: Props) {
  const [videoId, setVideoId] = React.useState<string>('');
  const [embedUrl, setEmbedUrl] = React.useState<string>('');

  useEffect(() => {
    const id = VideoUtilityService.extractYoutubeLinkID(link);
    setVideoId(id || '');
  }, [link]);

  // modestbranding & showinfo are deprecated url paramters for mminimizing/removing clickable links over video.
  // If we want to remove or minimze the links/branding, we should look into different video providers.
  useEffect(() => {
    if (!videoId) {
      setEmbedUrl('');
      return;
    }
    const originParam =
      typeof window !== 'undefined' && window.location?.origin
        ? `&origin=${encodeURIComponent(window.location.origin)}`
        : '';
    const url = `https://www.youtube-nocookie.com/embed/${videoId}?controls=1&rel=0&playsinline=1&enablejsapi=1${originParam}`; // modestbranding=1&showinfo=0
    setEmbedUrl(url);
  }, [videoId]);

  return (
    <div className='relative aspect-video max-w-full max-h-full bg-[#000] w-full h-auto rounded-2xl'>
      {embedUrl && (
        <iframe
          key={embedUrl}
          src={embedUrl}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '8px',
          }}
          title='Video Player'
          allow='autoplay; fullscreen; picture-in-picture; accelerometer; clipboard-write; encrypted-media; gyroscope'
          referrerPolicy='strict-origin-when-cross-origin'
          allowFullScreen
        />
      )}
    </div>
  );
}

YoutubeIFrame.propTypes = {
  link: PropTypes.string.isRequired,
};

export default YoutubeIFrame;
